import { useInjection } from 'inversify-react';

import { Text, useTheme } from '@desygner/ui-common-components';

import { TYPES } from '../../../../../inversify.types';
import { IViewerStoreInjector } from '../../../../../store';
import { StyledTimestampWrapper } from './Timestamp.styles';

export type TimestampProps = {
  currentTime: number;
};

export const Timestamp = ({ currentTime }: TimestampProps) => {
  const theme = useTheme();
  const useViewerStore = useInjection<IViewerStoreInjector>(TYPES.Store.Viewer);
  const currentMediaMetadata = useViewerStore((state) => state.currentPlayingMedia);

  function convertSecondsToTime(seconds?: number) {
    if (!seconds) return '0:00';

    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);

    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  }

  if (!currentMediaMetadata) return null;

  return (
    <StyledTimestampWrapper>
      <Text color={theme.Color.Neutrals.Text} size="Small">
        {convertSecondsToTime(currentTime)}
      </Text>
      <Text color={theme.Color.Neutrals.Text} size="Small">
        /
      </Text>
      <Text color={theme.Color.Neutrals.Text} size="Small">
        {convertSecondsToTime(currentMediaMetadata.totalDuration)}
      </Text>
    </StyledTimestampWrapper>
  );
};
